import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { handleResponse } from '../../ApiServices/ApiHandler';
import { t } from 'i18next';
import { createTaxes, getTaxes } from '../../ApiServices/TaxServices';

export const initialState = {
  value: { totalCount: -1, data: [] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  message: null
};

const taxesSlice = createSlice({
  name: 'tax',
  initialState: initialState,
  reducers: {
    clearTaxesState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.message = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchTaxes.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
    });
    builder.addCase(fetchTaxes.rejected, (state: any, action: any) => {
      state.loading = initialState.loading;
      state.error = action?.payload?.data;
    });
  }
});

export const taxesState = (state: RootState) => state?.taxes;
export const { clearTaxesState } = taxesSlice.actions;
export default taxesSlice.reducer;

export const fetchTaxes = createAsyncThunk(
  'tax/fetchTaxes',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_TAX') }));
      return fulfillWithValue(await getTaxes(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

export const addTaxes = createAsyncThunk(
  'tax/addTaxes',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('ADDING_NEW_TAX') }));
      let response = await createTaxes(payload);
      return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);

// export const fetchTax2 = createAsyncThunk(
//   'ingredient/fetchIngredients',
//   async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
//     try {
//       dispatch(showLoader({ message: t('FETCHING_TAX1') }));
//       return fulfillWithValue(await getIngredientsByPage(payload));
//     } catch (error) {
//       dispatch(showErrorSnackbar({ message: error }));
//       return rejectWithValue(error);
//     } finally {
//       dispatch(hideLoader());
//     }
//   }
// );

// export const addTax2 = createAsyncThunk(
//   'ingredient/addIngredient',
//   async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
//     try {
//       dispatch(showLoader({ message: t('ADDING_NEW_TAX1_DETAILS') }));
//       let response = await createIngredient(payload);
//       return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
//     } catch (error) {
//       dispatch(showErrorSnackbar({ message: error }));
//       return rejectWithValue(error);
//     } finally {
//       dispatch(hideLoader());
//     }
//   }
// );
